import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/apple-pay-logo.svg'
import _imports_1 from '@/assets/images/visa-logo.svg'
import _imports_2 from '@/assets/images/mastercard-logo.svg'
import _imports_3 from '@/assets/images/amex-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e76e670"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pay with card", -1))
const _hoisted_2 = { class: "checkout-payment-method-logos" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "Apple Pay"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Visa"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Mastercard"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Amex"
}, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'PayWithCardButton',
  setup(__props) {

function hasApplePayEnabled () {
  return !!window.ApplePaySession;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "checkout-payment-method-button",
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked')))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (hasApplePayEnabled())
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6
    ])
  ]))
}
}

})